<!-- 工程列表页面 -->
<template>
  <div class="eng-index-page">
    <el-container class="device-whole" style="width: 100%;margin: 0 auto">
      <el-header class="workheader clearfix">
        <div class="serchinp">
          <el-input type="text" placeholder="请输入关键词" v-model="inputvalue">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-button class="new-eng" type="primary" @click="createng">
          <i class="el-icon-circle-plus-outline"></i>
          <span style="font-size: 14px;">新建工程</span>
        </el-button>
      </el-header>
      <el-main class="content">
        <ul>
          <li v-for="(item,index) in workList" :key="index">
            <el-card class="box-card" :body-style="{ padding: '0px' }">
              <div slot="header" class="engineer" @click="skip(index)">
                <img src="../../assets/eng_bcg.png" height="100"/>
                <p style="font-size:14px">{{item.name}}</p>
              </div>
              <div>
                <el-container class="eng-foot">
                  <el-main class="time">{{item.createTime}}</el-main>
                  <el-aside class="dropdowm">
                    <el-dropdown trigger="click" placement="top-end">
                      <i class="el-input__icon el-icon-more icon"></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="rename(index)">
                          重命名
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="creatcopy(index)">
                          创建副本
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="removeEng(index)">
                          删除
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-aside>
                </el-container>
              </div>
            </el-card>
          </li>
        </ul>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import '../style/commom.scss'
import moment from 'moment';
import projectApi from '@/api/project';

export default {
  name: 'eng-index-page',
  data() {
    return {
      // 搜索的绑定值
      inputvalue: '',
      // 工程列表
      workList: [],
      workListBack: [],
    };
  },
  watch: {
    inputvalue: {
      handler(val) {
        if (val !== null) {
          val = val.replace(/^\s+|\s+$/g, '');// 加入g替换所有匹配
        }
        if (val === '') {
          this.workList = [...this.workListBack];// 复制数组
        } else {
          this.workList = this.workListBack.filter(item => item.name.indexOf(val) > -1);
        }
      },
      deep: true,
    },
  },
  created() {
    const self = this;
    document.onkeydown = function () {
      const key = window.event.keyCode;
      if (key === 13) {
        // 按Enter键时保持页面序号为1
        self.$store.commit('setPageIndex', 1);
      }
    };
  },
  mounted() {
    // 加载时默认设置页面序号为1
    this.$store.commit('setPageIndex', 1);
    this.getEngineDate();
  },
  methods: {
    createng() {
      const that = this;
      this.$prompt('工程名', '添加工程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '工程名不能重复或为空',
        // 添加工程校验的函数，返回false或true
        inputValidator(value) {
          console.log(value);
          console.log(that.workList);
          const index = that.workList.findIndex(item => item.name === value);
          return index < 0 && value !== null && value !== undefined;
        },
      }).then(({ value }) => {
        projectApi.create(value).then(() => {
          this.getEngineDate();
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    // 这个是获取工程列表的数据，需要多次调用
    getEngineDate() {
      projectApi.list()
        .then((res) => {
          this.workList = res.map((item) => {
            // item.createTime = moment(item.createTime).format('YYYY-MM-DD');
            const {
              createTime = '', creator = '', id = '', name = '',
            } = item;
            return {
              createTime: moment(createTime).format('YYYY-MM-DD'),
              name,
              id,
              creator,
            };
          });
          this.workListBack = [...this.workList];
        })
        .catch(() => {
        });
    },
    // 修改某一工程名字
    rename(index) {
      const that = this;
      this.$prompt('工程名', '修改工程名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '工程名不能重复或为空',
        // 添加工程校验的函数，返回false或true
        inputValidator(value) {
          let re;
          for (let i = 0; i < that.workList.length; i += 1) {
            if (value === that.workList[i].name || value === '' || value === null) {
              re = false;
              return re;
            }
            re = true;
          }
          return re;
        },
      }).then(({ value }) => {
        this.$post('project/rename', {
          id: this.workList[index].id,
          name: value,
        })
        // 以下逻辑进行了粗略修改，此前有bug res为undefined，导致无法显示消息和自动刷新
          .then(() => {
            this.$message({
              showClose: true,
              message: '重命名成功',
              type: 'success',
            });
            this.getEngineDate();
          }).catch((err) => {
            const { errorMsg = '' } = err;
            this.$message({
              showClose: true,
              message: '重命名失败',
              type: 'success',
            });
          });
      });
    },
    // 创建某一工程的副本
    creatcopy(index) {
      this.$confirm('此操作将会copy此工程, 是否继续?', '创建工程副本', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$post('project/copy', {
          id: this.workList[index].id,
        }).then((res) => {
          this.getEngineDate();
        }).catch((error) => {

        });
      }).catch(() => {

      });
    },
    // 删除某一工程
    removeEng(index) {
      this.$confirm('此操作将会删除此工程, 是否继续?', '删除工程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$post('project/delete', {
          id: this.workList[index].id,
        }).then(() => {
          this.getEngineDate();
        }).catch((error) => {
        });
      }).catch(() => {
      });
    },
    skip(index) {
      if (this.workList[index].id) {
        this.$router.push({
          name: 'detail',
          params: { id: this.workList[index].id, name: this.workList[index].name },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../style/mixin";
  @import '../../style/media';

  .eng-index-page {
    height: 100%;
    width: 100%;
    background: rgba(221, 221, 221, 0.17);
    overflow-x: auto;

    .device-whole {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;

      .workheader {
        flex-shrink: 0;
        flex-grow: 0;
        width: 100%;
        height: 80px !important;
        padding: 30px 40px 70px 40px;

        .serchinp {
          position: relative;
          width: 30%;
          @include min_1280 {
            width: 372px;
          }
        ;
          float: left;
          padding: 0;
          display: flex;
          flex-direction: column;
        }

        .new-eng {
          padding: 0 !important;
          float: right;
          display: -webkit-box;
          -webkit-box-pack: center;
          -webkit-box-orient: vertical;
          height: 40px;
          width: 288px;
          @include max_800 {
            width: 40%;
          }
          background: $main-color;
        }
      }

      .content {
        width: 100%;
        height: 100%;
        padding: 0;

        ul {
          padding: 20px 24px 0 24px;
          width: 100%;
          @include max_800 {
            width: 800px;
          }
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          align-content: flex-start;
          @include focus-scroll-bar;
        }

        li {
          width: 200px;
          margin: 30px 16px 0 16px;
          height: 200px;

          &:after {
            content: '';
            flex: auto;
          }
        }

        li {
          width: 200px;
          margin: 0px 16px 30px 16px;
          height: 200px;

          .engineer {
            height: 120px !important;
            text-align: center;
            cursor: pointer;
          }

          .eng-foot {
            width: 100%;
            height: 40px;
            padding: 0 !important;
            margin: 0 !important;
          }

          .time {
            color: $main-color;
            float: left;
            padding: 0 !important;
            padding-left: 20px !important;
            margin-top: 10px;
          }

          .dropdowm {
            width: 40px !important;
            overflow: hidden;
            padding: 0 !important;

            .icon {
              color: $main-color;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/engineering/index.vue